import React, { Fragment, useRef } from 'react';
import { NavLink, useParams, useLocation } from 'react-router-dom';
import data from '../data/portfolio.json';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const PortfolioDetails = () => {


 //-----------------------------// 
// FOR CLOSE BUTTON NAVIGATION BACK TO - History
// -------------------------- //
 const location = useLocation();
// Reads where the user came from, defaults to '/portfolio' if they loaded the page directly
  const returnPath = location.state?.from || '/portfolio';

  const containerRef = useRef(null);
  const lastValidPortfolio = useRef(null);
  const { design_slug } = useParams();

  // 1. Extract ID from current slug
  const portId = design_slug ? parseInt(design_slug.match(/\d+$/)?.[0], 10) : null;
  
  // Find item for current route
  const currentItem = data.find((item) => item.design_id === portId) || null;

  // Cache valid item to prevent exit-transition flashes
  if (currentItem) {
    lastValidPortfolio.current = currentItem;
  }

  // Use current item if present, otherwise fall back to cached item during route transition
  const portfolio = currentItem || lastValidPortfolio.current;

  // Filter out empty image paths into a clean array
  const imagePaths = [
    portfolio?.design_file_path_1,
    portfolio?.design_file_path_2,
    portfolio?.design_file_path_3,
    portfolio?.design_file_path_4,
    portfolio?.design_file_path_5
  ].filter(Boolean);







  
  useGSAP(() => {
    if (!portfolio) return;

    if (window.sScroll?.scrollTo) {
      window.sScroll.scrollTo(0, false);
    } else {
      window.scrollTo(0, 0);
    }

    // ANIMATIONS PAGE Headings and Info Panel
    // -------------------------------------- //
       gsap.set(".port-back-btn", { opacity: 0 });
       gsap.set(".pdp-info-window h2, .details-h1 h1", { opacity: 0 });
       gsap.set(".pdp-info-window", { x: 20, opacity: 0, perspective: 400, transformStyle: "preserve-3d" });
       gsap.set(".pdp-info-window strong, .pdp-info-window p", { y: 10, opacity: 0 });

       const  tl_details_window = gsap.timeline();
       tl_details_window.to(".port-back-btn", { opacity: 1, duration: 1 })
       .to(".details-h1 h1", { opacity: 1, duration: 1 })
      .to(".pdp-info-window", { x: 0, opacity: 1, duration: 0.5, transformOrigin: "center center"})
      .to(".pdp-info-window h2", { 
        opacity: 1, 
        duration: 1, 
        delay: -0.25, 
        onComplete: () => {

          
          // show details panel info
          gsap.to(".pdp-info-window strong, .pdp-info-window p", {
            y: 0,
            opacity: 1,
            duration: 0.25,
            stagger: 0.08,
            ease: "power1.out"
          });
          // show the copy below images
          /*
          gsap.to(".pdp-content h2, .pdp-content p", {
            opacity: 1,
            duration: 1.25,
            stagger: 0.08,
            ease: "power1.out"
          });
          */
        } 
      });


     // ===================================================== //
    // Image Preloading & Reveal Animation
    // ===================================================== //
     // presets
      gsap.set(".pdp-content h2, .pdp-content p", { x: 10, opacity: 0 });
     

    let loadedCounter = 0;
    imagePaths.forEach((url, idx) => {
      const slot = idx + 1;
      const imgEl = containerRef.current?.querySelector(`.port-img-0${slot} img`);
      const preloaderEl = containerRef.current?.querySelector(`.port-preloader-${slot}`);

      if (!imgEl || !url) return;

      // Ensure spinner is visible when preloading starts
      if (preloaderEl) {
        preloaderEl.classList.remove("pausespinner");
        gsap.set(preloaderEl, { display: "block", opacity: 1 });
      }

      const img = new Image();
      img.onload = () => {
        
        const wrapper = imgEl.parentElement;
        if (wrapper && img.naturalWidth && img.naturalHeight) {
          wrapper.style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`;
        }

        loadedCounter++;
        // Recalculate ScrollTrigger measurements immediately as each slot expands
        ScrollTrigger.refresh();
        
        if (preloaderEl) {
          gsap.timeline()
          // Hide Preloader
            .to(preloaderEl, { duration: 1.5, opacity: 0 })

            // show text heading copy first
            .to(".pdp-content h2", { duration: 0.5, x:0, opacity: 1 }, "-=0.25" )
            .to(".pdp-content p", { duration: 0.5, x:0, opacity: 1 }, "-=0.25" )
            // show image
            .to(imgEl, { duration: 1, opacity: 1 }, "-=0.25")



.to(".img-border-top", {
  "--start": "100%",
  "--end": "130%",
    duration: 0.5,     
    ease: "none" 
})
.to(".img-border-right", {
  "--start": "100%",
  "--end": "130%",
     duration: 0.5,     
    ease: "none" 
}, "<80%") 
.to(".img-border-bottom", {
  "--start": "100%",
  "--end": "130%",
     duration: 0.5,     
    ease: "none" 
}, "<80%")
.to(".img-border-left", {
  "--start": "100%",
  "--end": "130%",
     duration: 0.5,     
    ease: "none" 
}, "<80%")
.to(".img-border-top", {
  "--start": "100%",
  "--end": "130%",
    duration: 0.5,     
    ease: "none",
    overwrite: "auto" // ensures it registers cleanly 
}, "<80%")



            .call(() => {
              preloaderEl.classList.add("pausespinner");
              gsap.set(preloaderEl, { display: "none" });
            });
        } else {
          gsap.to(imgEl, { duration: 0.5, opacity: 1 });
        }

        if (loadedCounter === imagePaths.length) {
          ScrollTrigger.refresh();
          if (window.sScroll?.update) window.sScroll.update();
        }
      };
      img.src = url;
    });

const linkContainer = containerRef.current?.querySelector(".portfolio-url-link");
    if (linkContainer) {
      const anchorTag = linkContainer.querySelector("a");
      const linkHref = anchorTag?.getAttribute("href")?.trim().toLowerCase();
      
      if (!linkHref || linkHref === "none" || linkHref === "null" || linkHref.includes("undefined") || linkHref === "#") {
        gsap.set(linkContainer, { display: "none", opacity: 0, pointerEvents: "none" });
      }
    }







    
  }, { dependencies: [portfolio], scope: containerRef });








  if (!portfolio) {

    return (
      <main className="page-content page-id_portfolio-details">
        <div className="content portfolio-details-container">
          <h2>Portfolio Item Not Found</h2>
          <NavLink to="/portfolio" className="port-back-btn">Back to Portfolio</NavLink>
        </div>
      </main>
    );
  }

  return (
    <main className="page-content page-id_portfolio-details" data-page-id="portfolio-details" ref={containerRef}>
      <HelmetProvider>
        <Fragment>
          <Helmet>
            <title>{`MHD | ${portfolio.design_type || ''} - ${portfolio.design_client || ''}`}</title>
            <meta name="description" content={portfolio.design_description || ''} />
          </Helmet>
        </Fragment>
      </HelmetProvider>

      <div className="content portfolio-details-container">

        

     
   <div className="portfolio-display-panel">



          
<div className="pdp-content">



<div className="title-bar">
          <div className="port-back-btn-top-wrapper">
            <div className="port-back-btn-top">
              <NavLink to={returnPath} className="port-back-btn bottom"> Close</NavLink>
            </div>
          </div>

         <div className="details-h1">
          <h1>
           {portfolio.design_type} - {portfolio.design_client}
          </h1>
        </div>
         </div>



  {imagePaths.map((src, idx) => {
    const slot = idx + 1;
    const titleText = portfolio?.[`design_case_study_title_${slot}`];
    const copyText = portfolio?.[`design_case_study_copy_${slot}`];

    return (
      <React.Fragment key={slot}>

      
        {/* Title */}
        {titleText && (
          <h2 className={`port-title-0${slot}`} style={{ opacity: 0 }}>
            {titleText}
          </h2>
        )}

        {/* Copy */}
        {copyText && (
          <p className={`port-copy-0${slot}`} style={{ opacity: 0 }}>
            {copyText}
          </p>
        )}

         
        
        {/* Image Container */}
        <div className={`port-image-cont port-img-0${slot}`} style={{ aspectRatio: portfolio?.[`image_${slot}_ratio`] || '16 / 9' }}>
          <img src={src} alt={`portfolio image ${slot}`} style={{ opacity: 0 }} />
          <div className={`port-preloader-${slot}`}></div>

          <div className="img-borderfx img-border-top"></div>
          <div className="img-borderfx img-border-right"></div>
          <div className="img-borderfx img-border-bottom"></div>
          <div className="img-borderfx img-border-left"></div>
        </div>
       
      </React.Fragment>
    );
  })}
</div>

          <div className="pdp-info">
            
             <div className="pdp-info-window-wrapper">

            <div className="pdp-info-window" data-speed="1">
              <h2>Design Details</h2>
              <div className="pdp-info-grid">
                <div className="info-sect-1"><strong>Design Description</strong> <p>{portfolio.design_description}</p></div>
                <div className="info-sect-2"><strong>Design ID</strong> <p>{portfolio.design_id}</p></div>
                <div className="info-sect-3"><strong>Design Category</strong> <p>{portfolio.design_category}</p></div>
                <div className="info-sect-4"><strong>Design Type</strong> <p>{portfolio.design_type}</p></div>
                <div className="info-sect-5"><strong>Client</strong> <p>{portfolio.design_client}</p></div>
                <div className="info-sect-6"><strong>Design Tools</strong> <p>{portfolio.design_tools}</p></div>
                <div className="info-sect-7"><strong>Design Date</strong> <p>{portfolio.design_date}</p></div>
                <div className="info-sect-8"><strong>Design Keywords</strong> <p>{portfolio.design_keywords}</p></div>
              </div>

              <div className="portfolio-url-link">
                <strong>Design Link</strong>
                <p>
                  <a className="live-work-btn" href={portfolio.design_link} target="_blank" rel="noreferrer">
                   VIEW
                  </a>
                </p>
              </div>
            </div>
            </div>

          </div>
        </div>

        <NavLink to={returnPath} className="port-back-btn bottom"> Close</NavLink>
      </div>
    </main>
  );
};

export default PortfolioDetails;